import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. You can sign in now.");
      nav("/staff/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-paper" data-testid="reset-password">
      <div className="w-full max-w-md">
        <div className="eyebrow mb-3">New password</div>
        <h1 className="font-heading font-light text-4xl tracking-tighter">Set a new password.</h1>
        <form onSubmit={submit} className="mt-8 space-y-6">
          <div>
            <label className="eyebrow block mb-1">Reset token</label>
            <input required data-testid="reset-token" className="line-input" value={token} onChange={(e) => setToken(e.target.value)} />
          </div>
          <div>
            <label className="eyebrow block mb-1">New password</label>
            <input required type="password" data-testid="reset-password" className="line-input" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button disabled={loading} data-testid="reset-submit" className="w-full bg-ink text-white py-4 text-sm hover:bg-ink/90 disabled:opacity-60">
            {loading ? "Saving…" : "Reset password"}
          </button>
          <div className="text-xs"><Link to="/staff/login" className="text-stone hover:text-ink">Back to sign in</Link></div>
        </form>
      </div>
    </div>
  );
}
